(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@material/menu-surface')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/menu-surface', ['exports', '@angular/core', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@material/menu-surface'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.menuSurface = {}), global.ng.core, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.web.base, global.mdc.menuSurface));
}(this, (function (exports, core, coercion, platform, rxjs, operators, base, menuSurface) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var ANCHOR_CORNER_MAP = {
        topEnd: menuSurface.Corner.TOP_END,
        topStart: menuSurface.Corner.TOP_START,
        bottomEnd: menuSurface.Corner.BOTTOM_END,
        bottomStart: menuSurface.Corner.BOTTOM_START
    };
    var MdcMenuSurfaceBase = /** @class */ (function (_super) {
        __extends(MdcMenuSurfaceBase, _super);
        function MdcMenuSurfaceBase(changeDetectorRef, platform, _ngZone, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.changeDetectorRef = changeDetectorRef;
            _this.platform = platform;
            _this._ngZone = _ngZone;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._open = false;
            _this._anchorCorner = 'topStart';
            _this._quickOpen = false;
            _this._fixed = false;
            _this._coordinates = { x: 0, y: 0 };
            _this._anchorMargin = {};
            _this._hoistToBody = false;
            /** Emits an event whenever the menu surface is opened. */
            _this.opened = new core.EventEmitter();
            /** Emits an event whenever the menu surface is closed. */
            _this.closed = new core.EventEmitter();
            /** Subscription to interaction events in menu-surface. */
            _this._windowClickSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "open", {
            get: function () {
                return this._open;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._open) {
                    this._open = coercion.coerceBooleanProperty(value);
                    if (this._open) {
                        this._foundation.open();
                    }
                    else {
                        this._foundation.close();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "anchorElement", {
            get: function () {
                return this._anchorElement;
            },
            set: function (element) {
                this._anchorElement = element;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "anchorCorner", {
            get: function () {
                return this._anchorCorner;
            },
            set: function (value) {
                this._anchorCorner = value !== null && value !== void 0 ? value : 'topStart';
                this._foundation.setAnchorCorner(ANCHOR_CORNER_MAP[this._anchorCorner]);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "quickOpen", {
            get: function () {
                return this._quickOpen;
            },
            set: function (value) {
                this._quickOpen = coercion.coerceBooleanProperty(value);
                this._foundation.setQuickOpen(this._quickOpen);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "fixed", {
            get: function () {
                return this._fixed;
            },
            set: function (value) {
                this._fixed = coercion.coerceBooleanProperty(value);
                if (this._fixed) {
                    this._getHostElement().classList.add('mdc-menu-surface--fixed');
                }
                else {
                    this._getHostElement().classList.remove('mdc-menu-surface--fixed');
                }
                this._foundation.setFixedPosition(this._fixed);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "coordinates", {
            get: function () {
                return this._coordinates;
            },
            set: function (value) {
                this._coordinates = value;
                this._foundation.setAbsolutePosition(value.x, value.y);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "anchorMargin", {
            get: function () {
                return this._anchorMargin;
            },
            set: function (value) {
                this._anchorMargin = value;
                this._foundation.setAnchorMargin(this._anchorMargin);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "hoistToBody", {
            get: function () {
                return this._hoistToBody;
            },
            set: function (value) {
                this._hoistToBody = coercion.coerceBooleanProperty(value);
                if (this._hoistToBody) {
                    this.setHoistToBody();
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcMenuSurfaceBase.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                hasAnchor: function () { return !!_this.anchorElement; },
                notifyClose: function () {
                    _this.closed.emit();
                    _this._deregisterWindowClickListener();
                },
                notifyOpen: function () {
                    _this.opened.emit();
                    _this._registerWindowClickListener();
                },
                isElementInContainer: function (el) { return _this._getHostElement() === el || _this._getHostElement().contains(el); },
                isRtl: function () { return _this.platform.isBrowser ?
                    window.getComputedStyle(_this._getHostElement()).getPropertyValue('direction') === 'rtl' : false; },
                setTransformOrigin: function (origin) {
                    return _this.platform.isBrowser ?
                        _this._getHostElement().style[menuSurface.util.getTransformPropertyName(window) + "-origin"] = origin : false;
                },
                isFocused: function () { var _a; return (_a = (document === null || document === void 0 ? void 0 : document.activeElement) === _this._getHostElement()) !== null && _a !== void 0 ? _a : false; },
                saveFocus: function () { var _a; return _this._previousFocus = (_a = document === null || document === void 0 ? void 0 : document.activeElement) !== null && _a !== void 0 ? _a : undefined; },
                restoreFocus: function () {
                    var _a;
                    if (_this.platform.isBrowser) {
                        if (_this._getHostElement().contains(document.activeElement)) {
                            (_a = _this._previousFocus) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                    }
                },
                getInnerDimensions: function () {
                    return ({ width: _this._getHostElement().offsetWidth, height: _this._getHostElement().offsetHeight });
                },
                getAnchorDimensions: function () {
                    return _this.platform.isBrowser || !_this.anchorElement ?
                        _this._anchorElement.getBoundingClientRect() : { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
                },
                getWindowDimensions: function () { return ({
                    width: _this.platform.isBrowser ? window.innerWidth : 0,
                    height: _this.platform.isBrowser ? window.innerHeight : 0
                }); },
                getBodyDimensions: function () { return ({
                    width: _this.platform.isBrowser ? document.body.clientWidth : 0,
                    height: _this.platform.isBrowser ? document.body.clientHeight : 0
                }); },
                getWindowScroll: function () { return ({
                    x: _this.platform.isBrowser ? window.pageXOffset : 0,
                    y: _this.platform.isBrowser ? window.pageYOffset : 0
                }); },
                setPosition: function (position) {
                    _this._getHostElement().style.left = 'left' in position ? position.left + "px" : '';
                    _this._getHostElement().style.right = 'right' in position ? position.right + "px" : '';
                    _this._getHostElement().style.top = 'top' in position ? position.top + "px" : '';
                    _this._getHostElement().style.bottom = 'bottom' in position ? position.bottom + "px" : '';
                },
                setMaxHeight: function (height) { return _this._getHostElement().style.maxHeight = height; }
            };
            return new menuSurface.MDCMenuSurfaceFoundation(adapter);
        };
        MdcMenuSurfaceBase.prototype.initMenuSurface = function () {
            var _a;
            this._foundation.init();
            this.anchorElement = (_a = this._getHostElement().parentElement) !== null && _a !== void 0 ? _a : this.anchorElement;
            this._registerKeydownListener();
        };
        MdcMenuSurfaceBase.prototype.destroyMenuSurface = function () {
            this._destroy.next();
            this._destroy.complete();
            this._deregisterWindowClickListener();
            // add platform check due to use of cancelAnimationFrame inside destroy()
            if (this.platform.isBrowser) {
                this._foundation.destroy();
            }
            if (this.hoistToBody) {
                document.body.removeChild(this._getHostElement());
            }
        };
        /**
         * Removes the menu-surface from it's current location and appends it to the
         * body to overcome any overflow:hidden issues.
         */
        MdcMenuSurfaceBase.prototype.setHoistToBody = function () {
            if (!this.platform.isBrowser) {
                return;
            }
            var parentEl = this._getHostElement().parentElement;
            if (parentEl) {
                document.body.appendChild(parentEl.removeChild(this._getHostElement()));
                this._foundation.setIsHoisted(true);
            }
        };
        MdcMenuSurfaceBase.prototype._registerKeydownListener = function () {
            var _this = this;
            rxjs.fromEvent(this._getHostElement(), 'keydown')
                .pipe(operators.takeUntil(this._destroy))
                .subscribe(function (evt) {
                _this._foundation.handleKeydown(evt);
                _this._open = _this._foundation.isOpen();
            });
        };
        MdcMenuSurfaceBase.prototype._registerWindowClickListener = function () {
            var _this = this;
            if (!this.platform.isBrowser) {
                return;
            }
            this._windowClickSubscription =
                this._ngZone.runOutsideAngular(function () {
                    return rxjs.fromEvent(window, 'click')
                        .subscribe(function (evt) { return _this._ngZone.run(function () {
                        _this._foundation.handleBodyClick(evt);
                        _this._open = _this._foundation.isOpen();
                    }); });
                });
        };
        MdcMenuSurfaceBase.prototype._deregisterWindowClickListener = function () {
            var _a;
            (_a = this._windowClickSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        };
        /** Retrieves the DOM element of the component host. */
        MdcMenuSurfaceBase.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcMenuSurfaceBase.decorators = [
            { type: core.Directive }
        ];
        /** @nocollapse */
        MdcMenuSurfaceBase.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef },
            { type: platform.Platform },
            { type: core.NgZone, decorators: [{ type: core.Optional }] },
            { type: core.ElementRef }
        ]; };
        MdcMenuSurfaceBase.propDecorators = {
            open: [{ type: core.Input }],
            anchorElement: [{ type: core.Input }],
            anchorCorner: [{ type: core.Input }],
            quickOpen: [{ type: core.Input }],
            fixed: [{ type: core.Input }],
            coordinates: [{ type: core.Input }],
            anchorMargin: [{ type: core.Input }],
            hoistToBody: [{ type: core.Input }],
            opened: [{ type: core.Output }],
            closed: [{ type: core.Output }]
        };
        return MdcMenuSurfaceBase;
    }(base.MDCComponent));

    var MdcMenuSurface = /** @class */ (function (_super) {
        __extends(MdcMenuSurface, _super);
        function MdcMenuSurface() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MdcMenuSurface.prototype.ngOnInit = function () {
            this.initMenuSurface();
        };
        MdcMenuSurface.prototype.ngOnDestroy = function () {
            this.destroyMenuSurface();
        };
        MdcMenuSurface.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-menu-surface',
                        exportAs: 'mdcMenuSurface',
                        host: { 'class': 'mdc-menu-surface' },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        return MdcMenuSurface;
    }(MdcMenuSurfaceBase));

    var MdcMenuSurfaceAnchor = /** @class */ (function () {
        function MdcMenuSurfaceAnchor(elementRef) {
            this.elementRef = elementRef;
        }
        MdcMenuSurfaceAnchor.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcMenuSurfaceAnchor], mdc-menu-surface-anchor',
                        host: { 'class': 'mdc-menu-surface--anchor' }
                    },] }
        ];
        /** @nocollapse */
        MdcMenuSurfaceAnchor.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcMenuSurfaceAnchor;
    }());

    var MENU_SURFACE_DECLARATIONS = [
        MdcMenuSurface,
        MdcMenuSurfaceAnchor
    ];
    var MdcMenuSurfaceModule = /** @class */ (function () {
        function MdcMenuSurfaceModule() {
        }
        MdcMenuSurfaceModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [MENU_SURFACE_DECLARATIONS],
                        declarations: [MENU_SURFACE_DECLARATIONS]
                    },] }
        ];
        return MdcMenuSurfaceModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcMenuSurface = MdcMenuSurface;
    exports.MdcMenuSurfaceAnchor = MdcMenuSurfaceAnchor;
    exports.MdcMenuSurfaceBase = MdcMenuSurfaceBase;
    exports.MdcMenuSurfaceModule = MdcMenuSurfaceModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-menu-surface.umd.js.map
